export default __webpack_public_path__ + "0494ba85ceed59d5d368cde38bc59b5c.jpg";